// Phase 7 — Switch primitive (Radix). Token-styled replacement for antd <Switch>.
import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";
import { cn } from "lib/utils";

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    ref={ref}
    className={cn(
      "peer relative inline-flex h-5 w-9 shrink-0 cursor-pointer rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
      className
    )}
    {...props}
  >
    {/* Absolutely positioned (not flex-flow) so the thumb's travel distance is
        pinned to the track's padding-box, independent of any flex justify-content
        quirks — translate-x-0/4 move it exactly between the left and right edges. */}
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none absolute left-0 top-0 block h-4 w-4 translate-x-0 rounded-full bg-background shadow ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0"
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
